import { render, staticRenderFns } from "./VkLogin.vue?vue&type=template&id=7c0a8fae&scoped=true"
import script from "./VkLogin.vue?vue&type=script&lang=js"
export * from "./VkLogin.vue?vue&type=script&lang=js"
import style0 from "./VkLogin.vue?vue&type=style&index=0&id=7c0a8fae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a8fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c0a8fae')) {
      api.createRecord('7c0a8fae', component.options)
    } else {
      api.reload('7c0a8fae', component.options)
    }
    module.hot.accept("./VkLogin.vue?vue&type=template&id=7c0a8fae&scoped=true", function () {
      api.rerender('7c0a8fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VkLogin.vue"
export default component.exports